import logo from './logo.jpg';
import './App.css';
import {Route, Routes } from 'react-router-dom';
import Home from './Home';
import Contact from './pages/Contact';
function App() {
  return (
    <>
     <Routes> 
    <Route path="" element={<Home />} /> 
    <Route path="/Home" element={<Home />} /> 
    <Route path="/Contact" element={<Contact />} /> 
    </Routes> 
    </>
  );
}

export default App;
